import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { AuthenticationService } from '@app/services';
import { GlobalService } from '@app/services/global.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private globalService: GlobalService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        this.globalService.setMainLoading(true);
        if (currentUser && currentUser.access_token) {
            let token = currentUser.access_token;
            if (request.url.includes(environment.scs_url)) {
                token = currentUser.scs_access_token;
            }
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
        }

        return next.handle(request).pipe(
            finalize(() => {
                this.globalService.setMainLoading(false);
            })
        );
    }
}
